// import { Theme } from '@emotion/react';
import { useLocalStorage } from './useLocalStorage';

export function useTheme() {
  return useLocalStorage<string>('theme', 'light');
}
